import React, { useState, useLayoutEffect, useRef } from 'react';
import { googleMapsApiUrl } from 'utils/url';
import GoogleMapStyles from './GoogleMapStyles';
import { defaultProps, propTypes } from './GoogleMapHOCPropTypes';

const GoogleMapsHOC = (WrappedComponent) => {
  const GoogleMapsWrapper = (props) => {
    const { zoom, minZoom, maxZoom, center, mapContainerClassName } = props;

    const [map, setMap] = useState(null);
    const mapRef = useRef(null);
    const googleMapsRef = useRef(null);

    useLayoutEffect(() => {
      const initGoogleMap = () => {
        const gmaps = window.google.maps;
        googleMapsRef.current = gmaps;

        const mapOptions = {
          center,
          zoom,
          minZoom,
          maxZoom,
          disableDefaultUI: true,
          zoomControl: true,
          styles: GoogleMapStyles,
        };

        const mapInstance = new gmaps.Map(mapRef.current, mapOptions);
        setMap(mapInstance);
      };

      if (center?.lat && center?.lng) {
        if (window.googleMapsHasLoaded) {
          initGoogleMap();
        } else {
          if (!document.getElementById('googleMapsScript')) {
            const script = document.createElement('script');
            script.src = googleMapsApiUrl();
            script.setAttribute('id', 'googleMapsScript');
            document.getElementsByTagName('head')[0].appendChild(script);
          }
          window.googleMapsLoaded = () => {
            window.googleMapsHasLoaded = true;
            initGoogleMap();
          };
        }
      }

      return () => {
        window.document.removeEventListener('googleMapsLoaded', initGoogleMap);
      };
    }, []);

    return (
      <WrappedComponent {...props} map={map} googleMaps={googleMapsRef.current}>
        <div ref={mapRef} className={mapContainerClassName} />
      </WrappedComponent>
    );
  };

  GoogleMapsWrapper.propTypes = propTypes;
  GoogleMapsWrapper.defaultProps = defaultProps;

  return GoogleMapsWrapper;
};

export default GoogleMapsHOC;
